import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandMore } from "@material-ui/icons";
import Breadcrumbs from "components/Breadcrumbs";
import SEO from "components/SEO";
import SessionContext from "components/session/SessionContext";
import Title from "components/Title";
import { fetchPost, getTranslationContent, isArray } from "functions";
import Image from "next/image";
import { useContext } from "react";
import useTranslation from "translations/hooks/useTranslation";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    borderLeftColor: "#F5B750",
    borderLeftStyle: "solid",
    borderLeftWidth: 7,
    fontSize: 26,
    color: "#344450",
    fontWeight: "bold",
    padding: "2% 3%",
    margin: "2% 0 2% 10%",
    [theme.breakpoints.down("1100")]: {
      borderLeftWidth: 5,
      fontSize: 22,
    },
    [theme.breakpoints.down("769")]: {
      borderLeftWidth: 3,
      fontSize: 18,
    },
  },
  termsofUse: {
    display: "flex",
    flexDirection: "row",
    alignSelf: "center",
    width: "80%",
    height: "auto",
    backgroundColor: "#E4E4E4",
    padding: "2% 0",
    [theme.breakpoints.down("769")]: {
      width: "90%",
    },
    marginBottom: "3%",
  },
  shape: {
    width: "40%",
    height: 700,
    [theme.breakpoints.down("769")]: {
      display: "none",
    },
  },
  termsofUseContainer: {
    height: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "2%",
  },
  question: {
    width: "100%",
    borderLeftColor: "#F5B750",
    borderLeftStyle: "solid",
    borderLeftWidth: 5,
    fontSize: 16,
    color: "#344450",
    fontWeight: "bold",
    padding: "0.5% 2%",
    [theme.breakpoints.down("1100")]: {
      borderLeftWidth: 4,
      fontSize: 14,
    },
    [theme.breakpoints.down("769")]: {
      borderLeftWidth: 3,
      fontSize: 12,
    },
  },
  answer: {
    fontSize: 14,
    color: "#344450",
    padding: "0 4%",
    [theme.breakpoints.down("1100")]: {
      fontSize: 12,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 10,
    },
  },
  accordion: {
    margin: "2%",
    padding: "1% 4%",
  },
}));

export default function TermsofUse({ data }) {
  const classes = useStyles();
  const { t } = useTranslation();

  let {
    session: { lang },
  } = useContext(SessionContext);

  var breadcrumbs = [{ text: t("home"), href: "/" }, { text: t("termOfUse") }];

  return (
    <Box display="flex" flexDirection="column" width={"100%"}>
      <SEO title={t("termOfUse")} description={t("termsOfUse")} />
      <Breadcrumbs items={breadcrumbs} />
      <Title text={t("termOfUse")} />
      <Box className={classes.termsofUse}>
        <Box className={classes.shape}>
          <Image src="/Shape.png" alt="shape" width={100} height={700} />
        </Box>
        <Box className={classes.termsofUseContainer}>
          {data &&
            isArray(data) &&
            data.map((item) => (
              <Accordion className={classes.accordion} key={item._id}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Box className={classes.question}>
                    {getTranslationContent(item, "title", lang)}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    dangerouslySetInnerHTML={{
                      __html: getTranslationContent(item, "body", lang),
                    }}
                    className={classes.answer}
                  />
                </AccordionDetails>
              </Accordion>
            ))}
        </Box>
      </Box>
    </Box>
  );
}

export async function getServerSideProps(context) {
  let data = {};
  let { lang } = context.query;
  let response = await fetchPost({ apiName: "faq", reqBody: { lang } });
  data = response?.response;
  return { props: { data } };
}
